export default function READBOOK({ children }) {
  return (
    <>
      <p>
        A silent auction featuring a selection of beautifully worn books that do not rely on the
        book title or any speculative value. Participants to the auction are invited to interact
        with the books to decide on the deserved value.
      </p>
      <p>
        10 books, each chosen for the theme "What’s Wrong With Well Worn?", are up for auction with
        a base price of $30. To bid, write your offer and details, then deposit the form in the box.
        Bids are confidential and winners will be notified within 14 days. Proceeds will go to
        UNICEF.
      </p>
      {children}
    </>
  );
}
